// Brief item titles can arrive HTML-encoded (e.g. `&amp;`).
export default function decodeHtmlEntities(str: string): string {
  const el = document.createElement('textarea');
  el.innerHTML = str;
  return el.value;
}
